export default __webpack_public_path__ + "static/media/rar.0c2fb4f2.svg";